import { useEffect } from 'react';

// UI
import Button from '@components/button';

// assets
import titleImg from '@assets/404-title.svg';
import textImg from '@assets/404-text.svg';

// styles
import css from './styles.module.css';

function NotFound() {
  useEffect(() => {
    document.body.classList.add('adjust-for-onboarding-pages');

    return () => {
      document.body.classList.remove('adjust-for-onboarding-pages');
    };
  }, []);

  return (
    <main className={css.error}>
      <div className={css.titleWrapper}>
        <img src={titleImg} alt="not found" title="404" />
      </div>

      <div className={css.textWrapper}>
        <img className={css.textImg} src={textImg} alt="" title="" />
      </div>

      <a href="/">
        <Button className={css.button} size="large">
          Send me back home
        </Button>
      </a>

      <p className={css.text}>
        Need any help? Contact{' '}
        <a href="mailto:support@turbopush.io">support@turbopush.io</a>
      </p>
    </main>
  );
}

export default NotFound;
